import angular from 'angular'
import template from './template.html'

export default class NominasPendientesCotizarProyectoNominaAprobarDispersionComponent {
  constructor ($state, NominasNominaDispersion) {
    this.$state = $state
    this.NominasNominaDispersion = NominasNominaDispersion
    this.idProyecto = null
    this.idNomina = null
    this.idTipoPago = null
  }

  $onInit () {
    this.promise = this.NominasNominaDispersion.get(this.idProyecto, this.idNomina)
      .then((response) => {
        this.data = response.data

        if (this.data.tipos_pago.length) {
          this.idTipoPago = this.data.tipos_pago[0].id_tipo_pago
        }
      })
      .catch((response) => (this.error = response.data))
  }

  cerrar () {
    this.onClose()
  }

  siguiente () {
    let indice = this.data.tipos_pago.findIndex((item) => this.idTipoPago === item.id_tipo_pago)
    this.idTipoPago = (this.data.tipos_pago[indice + 1] || {id_tipo_pago: null}).id_tipo_pago
  }
}

angular.module('nominas.pendientes')
  .component('nominasPendientesCotizarProyectoNominaAprobarDispersion', {
    controller: NominasPendientesCotizarProyectoNominaAprobarDispersionComponent,
    template: template,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      onClose: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/pendientes/components/cotizar/proyecto/nomina/aprobar/dispersion/component.js